import { DOCUMENT } from '@angular/common';
import { APP_INITIALIZER, Provider } from '@angular/core';
import { CdnPathService } from '../shared/services/cdn-path.service';

export function brandingInitializerFactory(doc: Document, cdnPathService: CdnPathService) {
    // Angular calls the returned function during app bootstrap.
    return (): void => {
        const setHref = (id: string, href: string): void => {
            const link: HTMLLinkElement | null = doc.getElementById(id) as HTMLLinkElement | null;
            if (link) {
                link.href = href;
            }
        };

        // CSS
        setHref('nwn-framework-css', cdnPathService.frameworkCss());
        setHref('nwn-client-css', cdnPathService.clientCss());
        setHref('nwn-fontawesome-css', cdnPathService.fontAwesomeCss());

        // Icons
        setHref('nwn-icon', cdnPathService.imageUrlClient('icon.png'));
        setHref('nwn-shortcut-icon', cdnPathService.imageUrlClient('icon.png'));
    };
}

/** Runs once at bootstrap to populate <link> HREFs in index.html with CDN paths. */
export const BrandingInitializerProvider: Provider = {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: brandingInitializerFactory,
    deps: [DOCUMENT, CdnPathService],
};
